import { render } from "./ChatRecordFileComponent.vue?vue&type=template&id=6a8cfc8d&scoped=true"
import script from "./ChatRecordFileComponent.vue?vue&type=script&lang=js"
export * from "./ChatRecordFileComponent.vue?vue&type=script&lang=js"

import "./ChatRecordFileComponent.vue?vue&type=style&index=0&id=6a8cfc8d&lang=scss&scoped=true"

import exportComponent from "C:\\www\\farming_chat_pc_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8cfc8d"]])

export default __exports__